import Proj1 from "../assets/proj1.jpg";
import Proj2 from "../assets/proj2.jpg";
import Proj3 from "../assets/proj3.png";
import Proj4 from "../assets/proj4.webp";
import theme from "../assets/theme.png";
import grading from "../assets/grading.jpeg"
import gBuddy from "../assets/groceryBuddy.webp";
import got from "../assets/got.png";
import cars from "../assets/cars.jpeg";
import typing from "../assets/typing.png";
import ttt from "../assets/ttt.png";
import jira from "../assets/jira.png";
import taskTracker from "../assets/taskTracker.jpg";
import pomo from "../assets/pomo.jpeg";

export const ProjectList = [
  {
    name: "JIRA Clone",
    image: jira,
    skills: "React, Remix Run SSR, Radix for UI component, tailwind css, SQLite, Prisma",
    ghlink: "https://github.com/Mahendra14/jira_clone"
  },
  {
    name: "SMART Driving Companion - Advanced Infotainment System",
    image: cars,
    skills: "React Native, Django, Matlab, Fuzzy Algorithm",
    ghlink: "https://github.com/Mahendra14/Smart-Driving-Companion"
  },
  {
    name: "Practice Typing",
    image: typing,
    skills: "React Native, Django, Matlab, Fuzzy Algorithm",
    ghlink: "https://github.com/Mahendra14"
  },
  {
    name: "2048 Clone",
    image: Proj3,
    skills: "React,Node.js,MongoDB,SpotifyAPI",
    ghlink: "https://github.com/Mahendra14"
  },
  {
    name: "Pomodoro Google Extension",
    image: pomo,
    skills: "Google Extension, Javascript, Html, CSS, manifest.json",
    ghlink: "https://github.com/Mahendra14/pomodoChromeExtension"
  },
  {
    name: "Task Tracker",
    image: taskTracker,
    skills: "React, TailwindCSS, Node",
    ghlink: "https://github.com/Mahendra14/Task-Tracker"
  },
  {
    name: "VS Code Theme",
    image: theme,
    skills: "Theming Standards, JS",
    ghlink: "https://github.com/Mahendra14/Dark-Theme-Extension"
  },
  {
    name: "Auto Grader Tool",
    image: grading,
    skills: "Node, CLI, Javascript, Complex Algorithm, C++",
    ghlink: "https://github.com/Mahendra14/autoGradingTool"
  },
  {
    name: "Grocery Buddy List and Reminder",
    image: gBuddy,
    skills: "React, TailwindCSS, JavaScript,HTML,CSS",
    ghlink: "https://github.com/Mahendra14/GroceryBuddy-ReactJs"
  },
  {
    name: "Game Of Thrones Quiz",
    image: got,
    skills: "Node, CLI",
    ghlink: "https://github.com/Mahendra14/GOTFandom_cli_app"
  },

];

// {
//   name: "Fun Tic-Tac-Toe Game",
//   image: ttt,
//   skills: "React Native, Django, Matlab, Fuzzy Algorithm",
//   ghlink: "https://github.com/Mahendra14"
// },